export var OrderCancellationReason;
(function (OrderCancellationReason) {
    OrderCancellationReason["NO_LONGER_NEEDED"] = "NO_LONGER_NEEDED";
    OrderCancellationReason["WRONG_TEST"] = "WRONG_TEST";
    OrderCancellationReason["UNABLE_TO_FAST"] = "UNABLE_TO_FAST";
    OrderCancellationReason["UNABLE_TO_PERFORM"] = "UNABLE_TO_PERFORM";
    OrderCancellationReason["OTHER"] = "OTHER";
    OrderCancellationReason["EXPIRED"] = "EXPIRED";
})(OrderCancellationReason || (OrderCancellationReason = {}));
